import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import applicationReducer from './ApplicationSlice';

const rootReducer = combineReducers({
  intakeData: applicationReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
